import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UIStore } from '../../core//ui/ui.store';
import { FeedbackComponent } from '../../features/feedback/feedback';
import { LoggerService } from '../../core/logging/logger.service';

@Component({
  selector: 'app-protected',
  imports: [RouterOutlet, FeedbackComponent],
  templateUrl: './protected.html',
  styleUrls: ['./protected.css'],
})
export class ProtectedComponent implements OnInit {
  // To open feedback dialog from the header, we need to inject the UIService here and pass it to the header component.
  uiStore = inject(UIStore);
  private logger = inject(LoggerService);

  ngOnInit() {
      this.logger.info('ProtectedComponent', 'Component initialized and displayed to authenticated user');
      this.logger.debug('ProtectedComponent', 'Feedback form state', { isOpen: this.uiStore.feedbackTemplateOpen() });
  }
}
